import { render, staticRenderFns } from "./FormCategory.vue?vue&type=template&id=583ba710"
import script from "./FormCategory.vue?vue&type=script&lang=js"
export * from "./FormCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormCategory.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('583ba710')) {
      api.createRecord('583ba710', component.options)
    } else {
      api.reload('583ba710', component.options)
    }
    module.hot.accept("./FormCategory.vue?vue&type=template&id=583ba710", function () {
      api.rerender('583ba710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/FormCategory.vue"
export default component.exports